import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import { FC } from 'react';

interface IProps {
  title: string;
  subTitle: string;
  buttonText: string;
  href?: string;
}
const CtaSection: FC<IProps> = ({ title, subTitle, buttonText, href }) => {
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  return (
    <Box>
      {/* <Typography
        sx={{
          textTransform: 'uppercase',
          fontWeight: 'medium',
        }}
        gutterBottom
        color={'text.secondary'}
      >
        {t('Employer of Record')}
      </Typography> */}
      <Box marginBottom={2}>
        <Typography
          variant="h2"
          color="text.primary"
          sx={{
            fontWeight: 700,
            fontSize: '56px',
          }}
        >
          {title}
        </Typography>
      </Box>
      <Box marginBottom={3}>
        <Typography
          variant="h6"
          component="p"
          color="text.secondary"
          sx={{
            fontSize: '18px',
          }}
        >
          {subTitle}
        </Typography>
      </Box>
      <Box
        display="flex"
        flexDirection={{ xs: 'column', sm: 'row' }}
        alignItems={{ xs: 'stretched', sm: 'flex-start' }}
      >
        <Box
          component={Button}
          variant="outlined"
          color="primary"
          size="large"
          marginTop={{ xs: 2, sm: 0 }}
          fullWidth={isMd ? false : true}
          href={href || '/book-demo'}
        >
          {buttonText}
        </Box>
      </Box>
    </Box>
  );
};

export default CtaSection;
